<template>
  <section class="block-info border">
    <div class="container">
      <div class="slider">
        <!-- slider -->
        <agile ref="agile" :options="options">
          <div class="slide" v-for="(slide, index) in data.list_images" :key="index">
            <img :src="slide.image" />
            <div class="description" v-html="slide.text" />
          </div>
          <template slot="prevButton">
            <v-icon name="chevron-left" />
          </template>
          <template slot="nextButton">
            <v-icon name="chevron-right" />
          </template>
        </agile>
        <!-- /slider -->
      </div>
      <div class="container-info" :class="`align-${position}`">
        <div class="info-area" v-html="data.area" />
        <div class="info-title" v-html="data.title" />
        <div class="info-text" v-html="data.text" />
        <div class="scrolling-wrapper hide-desktop">
          <div class="card slide" v-for="(slide, index) in data.list_images" :key="index">
            <img :src="slide.image" />
            <div class="description" v-html="slide.text" />
          </div>
        </div>
        <ul class="info-list">
          <li v-for="(item, index) in data.list" :key="index">
            <div class="text" v-html="item.text" />
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["data", "position"],
  data() {
    return {
      options: {
        slidesToShow: 2,
        dots: false,
      },
    };
  },
};
</script>

<style lang="scss" src="./BlockInfoProduct.scss" />